import { render } from "./BannerGeneric.vue?vue&type=template&id=757ea0ab&scoped=true"
import script from "./BannerGeneric.vue?vue&type=script&lang=js"
export * from "./BannerGeneric.vue?vue&type=script&lang=js"

import "./BannerGeneric.vue?vue&type=style&index=0&id=757ea0ab&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-757ea0ab"]])

export default __exports__